module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/122.d8522fc5.svg";